import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import BacktestService from "../../../../service/backtest.service";
import ContainerDimensions from "react-container-dimensions";
import Slider from "react-slick";
import ModelCard from "../model_card";
import RiskRangeChart from "../../../common/riskRangeChart";
import SliderSettings from "../common/sliderSettings";
import TreeTableWithSlider from "../../../common/treeTableWithSlider";
import TunersAndInput from "../common/tunersAndinput";
import helper from "../helper.js";
import debounce from "../../../common/debounce";
import "./BuildPortfolio.style.scss";

class BuildPortfolio extends Component {
  state = {
    modelportfolios: [],
    scenario_short_list: {},
    // backtest_data: {},
    riskRangePercentage: 30,
    reRender: false,
    createBtnDisabled: true,
    activeSliders: [],
    grouped_data: [],
    slider_colors: [
      "#5099d4",
      "#fa7d2e",
      "#8A8A8A",
      "#B53F18",
      "#747A80",
      "#F26F6F",
      "#BA3F3F",
    ],
    styleAssetClassGroups: {},
    colorsAssetClassGroups: {},
    minRange: "",
    maxRange: "",
    idAssociatedValue: {},
    creatingPortfolioSpinner: false,
    failedCreatingPortfolio: false,
    noScenarioIDreturned: false,
  };

  componentDidMount() {
    const {
      direct_review_orig_scenario_id,
      direct_review_portfolio,
    } = this.props;
    // risk range
    if (
      this.props.build_modelportfolios &&
      this.props.build_modelportfolios.length > 0
    ) {
      let getRiskMinMaxRange = helper.getRiskMinMaxRange({
        modelportfolios: this.props.build_modelportfolios,
      });
      if (getRiskMinMaxRange && Object.keys(getRiskMinMaxRange).length > 0) {
        this.setState({
          modelportfolios: this.props.build_modelportfolios,
          scenario_short_list: this.props.scenario_short_list_symbols,
          // backtest_data: this.props.backtest_data,
          minRange: getRiskMinMaxRange["min"],
          maxRange: getRiskMinMaxRange["max"],
          idAssociatedValue: getRiskMinMaxRange["idAssociatedValue"],
        });
      }
    }

    // if it is direct review portfolio
    // activate portfolio based on selected id
    if (direct_review_orig_scenario_id && direct_review_portfolio) {
      this.radioButtonHandler({
        value: direct_review_orig_scenario_id,
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      JSON.stringify(this.state.scenario_short_list) !==
      JSON.stringify(prevState.scenario_short_list)
    ) {
      // risk range
      if (
        this.props.build_modelportfolios &&
        this.props.build_modelportfolios.length > 0
      ) {
        let getRiskMinMaxRange = helper.getRiskMinMaxRange({
          modelportfolios: prevProps.build_modelportfolios,
        });

        if (getRiskMinMaxRange && Object.keys(getRiskMinMaxRange).length > 0) {
          this.setState({
            scenario_short_list: prevProps.scenario_short_list_symbols,
            modelPortfolios: prevProps.build_modelportfolios,
            minRange: getRiskMinMaxRange["min"],
            maxRange: getRiskMinMaxRange["max"],
            idAssociatedValue: getRiskMinMaxRange["idAssociatedValue"],
          });
        }
      }

      return true;
    } else {
      return false;
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentWillReceiveProps(nextProps) {
    // risk range
    let getRiskMinMaxRange = helper.getRiskMinMaxRange({
      modelportfolios: nextProps.build_modelportfolios,
    });

    if (
      nextProps.build_modelportfolios &&
      nextProps.build_modelportfolios.length > 0
    ) {
      this.setState({
        modelportfolios: nextProps.build_modelportfolios,
        scenario_short_list: nextProps.scenario_short_list_symbols,
        // backtest_data: nextProps.backtest_data,
        minRange:
          Object.keys(getRiskMinMaxRange).length > 0
            ? getRiskMinMaxRange["min"]
            : 0,
        maxRange:
          Object.keys(getRiskMinMaxRange).length > 0
            ? getRiskMinMaxRange["max"]
            : 0,
        idAssociatedValue:
          Object.keys(getRiskMinMaxRange).length > 0
            ? getRiskMinMaxRange["idAssociatedValue"]
            : {},
      });
    }
  }

  sliderRangeHandler = (obj) => {
    const { min, max, name, group } = obj;
    const { setDualSliderValues, direct_review_portfolio } = this.props;
    let grp = direct_review_portfolio ? `direct_review_${group}` : group;
    let object = { min, max, name, group: grp };
    setDualSliderValues(object);
  };

  radioButtonHandler = ({ value }) => {
    if (value) {
      const { setBuildAPortfolioID } = this.props;

      setBuildAPortfolioID({
        activePortfolioID: value.toString(),
        group: "build_a_portfolio",
      });

      // set cash max value to 100 minus sum of rest
      setTimeout(() => this.set_cash_assetClass_min_max_value(), 100);
    }
  };
  set_cash_assetClass_min_max_value = () => {
    const { overall_focus } = this.props;
    // setting cash asset class value to 100 - total of other asset classes
    if (overall_focus && overall_focus.length > 0) {
      let min = 0;
      let max =
        100 -
        overall_focus
          .filter((e) => e.name.toLowerCase() !== "cash")
          .map((a) => a.max * 1)
          .reduce((a, b) => a * 1 + b * 1) *
          100;

      let object = {
        min,
        max: max < 0 ? 0 : max,
        name: "Cash",
        group: "overall_focus",
      };
      this.sliderRangeHandler(object);
    }
  };

  tunersHandler = (obj) => {
    const { id, type, value } = obj;
    this.props.tunersHandler({
      id,
      type,
      value: +value,
    });
  };
  portfolioNameHandler = (name) => {
    const { setBuildScenarioName } = this.props;

    setBuildScenarioName({
      scenario_name: name,
      group: "build_a_portfolio",
    });

    if (name === "") {
      this.setState({
        createBtnDisabled: true,
      });
    } else {
      this.setState({
        createBtnDisabled: false,
      });
    }
  };

  toggleStyleRowHandler = ({ e, cls }) => {
    e.preventDefault();
    let { target } = e;
    let plus = [...target.classList].includes("fa-plus");

    if (plus === true) {
      target.classList.remove("fa-plus");
      target.classList.add("fa-minus");
    } else {
      target.classList.add("fa-plus");
      target.classList.remove("fa-minus");
    }

    let listOfStyles = document.querySelectorAll(`.${cls}`);

    for (let i = 0; i < listOfStyles.length; i++) {
      let item = listOfStyles[i];
      let condition = [...item.classList].includes("hideBuildTableCell");

      if (condition) {
        item.classList.remove("hideBuildTableCell");
        item.classList.add("showBuildTableCell");
      } else {
        item.classList.add("hideBuildTableCell");
        item.classList.remove("showBuildTableCell");
      }
    }
  };

  finish = () => {
    const {
      active_portfolio_id,
      scenario_name,
      optimization_params,
      overall_focus,
      asset_class,
      styles,
      fund_type,
      scenario_short_list_symbols,
      symbol_orders,
      deleteSecurities,
      build_a_portfolio_type,
      build_modelportfolios,
      direct_review_orig_scenario_id,
      direct_review_scenario_id,
      direct_review_portfolio,
      direct_review_fund_type,
      direct_review_asset_class,
      direct_review_overall_focus,
      direct_review_styles,
      direct_review_optimization_params,
      direct_review_scenario_shortlist_symbols,
      resetBuildDirectReview,
    } = this.props;

    let _fund_type = direct_review_portfolio
      ? direct_review_fund_type
      : fund_type;
    let _asset_class = direct_review_portfolio
      ? direct_review_asset_class
      : asset_class;
    let _overall_focus = direct_review_portfolio
      ? direct_review_overall_focus
      : overall_focus;
    let _styles = direct_review_portfolio ? direct_review_styles : styles;

    let ft = _fund_type ? [..._fund_type] : null;
    let cash = ft && ft.find((x) => x.name.toLowerCase() === "cash");

    let ac = _asset_class ? [..._asset_class] : null;

    let ofo = _overall_focus ? [..._overall_focus] : null;
    let ofo_cash = ofo && ofo.filter((e) => e.name.toLowerCase() === "cash");

    if (cash) {
      ac.push(cash);
      if (ofo_cash && ofo_cash.length > 0) {
        ofo.push(cash);
      }
    }

    let s = _styles ? [..._styles] : null;

    if (cash) {
      let tmp = {};
      tmp["style"] = cash["name"];
      tmp["min"] = cash["min"];
      tmp["max"] = cash["max"];
      tmp["value"] = cash["min"];
      tmp["value2"] = cash["max"];
      s.push(tmp);
    } else {
      cash = { name: "Cash", min: "0", max: "0.0" };

      let tmp = {};
      tmp["style"] = cash["name"];
      tmp["min"] = cash["min"];
      tmp["max"] = cash["max"];
      tmp["value"] = cash["min"];
      tmp["value2"] = cash["max"];
      s.push(tmp);
    }

    const addMinMax = (data, type) => {
      if (!data) return;
      let modifiedData = [];

      for (let i = 0; i < data.length; i++) {
        let obj = {};
        if (type === "style") {
          obj["name"] = data[i]["style"];
          obj["style"] = data[i]["style"];
        } else {
          obj["name"] = data[i]["name"];
        }
        obj["value"] = data[i]["min"];
        obj["value2"] = data[i]["max"];
        obj["min"] = data[i]["min"];
        obj["max"] = data[i]["max"];

        modifiedData.push(obj);
      }
      return modifiedData;
    };

    let sendData = {
      optimization_params:
        direct_review_orig_scenario_id && direct_review_portfolio
          ? {
              ...direct_review_optimization_params[direct_review_scenario_id],
            }
          : {
              ...optimization_params[active_portfolio_id],
            },
      fund_type: addMinMax(ft),
      asset_class: addMinMax(ac),
      overall_focus: addMinMax(ofo),
      styles: addMinMax(s, "style"),
      shortlist:
        direct_review_portfolio &&
        direct_review_scenario_shortlist_symbols &&
        direct_review_scenario_shortlist_symbols.length > 0
          ? [
              ...direct_review_scenario_shortlist_symbols
                .filter((e) => !deleteSecurities.includes(e.symbol))
                .map((s) => ({
                  symbol: s.symbol,
                  val: s.val ? s.val / 100 : null,
                  order:
                    Object.keys(symbol_orders).length > 0
                      ? symbol_orders[s.symbol] &&
                        symbol_orders[s.symbol].toString()
                      : null,
                })),
            ]
          : [
              ...scenario_short_list_symbols[active_portfolio_id]
                .filter((e) => !deleteSecurities.includes(e.symbol))
                .map((s) => ({
                  symbol: s.symbol,
                  val: s.val ? s.val / 100 : null,
                  order:
                    Object.keys(symbol_orders).length > 0
                      ? symbol_orders[s.symbol] &&
                        symbol_orders[s.symbol].toString()
                      : null,
                })),
            ],
    };

    let _filtered = build_modelportfolios.filter(
      (e) => e.id === active_portfolio_id
    );
    let reference_scenario_id =
      build_a_portfolio_type === "customPortfolio" &&
      _filtered &&
      _filtered.length > 0 &&
      _filtered[0]["data"][0]["reference_scenario_id"]
        ? _filtered[0]["data"][0]["reference_scenario_id"]
        : 0;

    BacktestService.createPortfolio({
      portfolio_id:
        build_a_portfolio_type === "customPortfolio" &&
        reference_scenario_id !== 0
          ? reference_scenario_id
          : active_portfolio_id,
      scenario_id: "",
      scenario_name: scenario_name,
      type: "CURRENT",
      portfolio_type:
        build_a_portfolio_type === "managerSelection"
          ? "MS"
          : build_a_portfolio_type === "customPortfolio"
          ? "CP"
          : "",
      ui_params: JSON.stringify(sendData),
      // analyze an existing portfolio parameters
      orig_scenario_id: 0,
      client_portfolio_id:
        direct_review_orig_scenario_id &&
        direct_review_portfolio &&
        direct_review_scenario_id
          ? direct_review_scenario_id
          : 0,
    })
      .then((res) => {
        if (res) {
          this.setState({
            creatingPortfolioSpinner: false,
          });
          if ("scenario_id" in res && res["scenario_id"]) {
            this.setState({
              noScenarioIDreturned: false,
            });
            browserHistory.push("/portfolio/" + res.scenario_id);

            // resetting Direct Review portfolio data
            resetBuildDirectReview();
          } else {
            this.setState({
              noScenarioIDreturned: true,
            });

            setTimeout(
              () =>
                this.setState({
                  noScenarioIDreturned: false,
                }),
              500
            );
          }
          // reset build portfolio
          this.props.resetBuildPortfolio();
        }
      })
      .catch((err) => {
        console.log("crete portfolio error", err);
        this.setState({
          creatingPortfolioSpinner: false,
          failedCreatingPortfolio: true,
          noScenarioIDreturned: false,
        });

        setTimeout(
          () => this.setState({ failedCreatingPortfolio: false }),
          5000
        );
      });

    // clear name
    this.props.setBuildScenarioName({
      scenario_name: "",
      group: "build_a_portfolio",
    });
  };
  createPortfolioHandler = () => {
    this.setState({
      creatingPortfolioSpinner: true,
    });

    debounce(this.finish(), 500);
  };
  render() {
    const {
      modelportfolios,
      // backtest_data,
      createBtnDisabled,
      minRange,
      maxRange,
      idAssociatedValue,
      creatingPortfolioSpinner,
      failedCreatingPortfolio,
      noScenarioIDreturned,
    } = this.state;

    const {
      active_portfolio_id,
      optimization_params,
      scenario_name,
      overall_focus,
      asset_class,
      styles,
      build_histmetrics,
      build_a_portfolio_type,
      direct_review_orig_scenario_id,
      direct_review_portfolio,
      direct_review_scenario_id,
      direct_review_optimization_params,
      direct_review_overall_focus,
      direct_review_asset_class,
      direct_review_styles,
      direct_review_scenario_shortlist_symbols,
    } = this.props;

    let max_value =
      direct_review_portfolio &&
      direct_review_scenario_id &&
      direct_review_optimization_params[direct_review_scenario_id.toString()] &&
      direct_review_optimization_params[direct_review_scenario_id.toString()][
        "max_vol"
      ]
        ? direct_review_optimization_params[
            direct_review_scenario_id.toString()
          ]["max_vol"]
        : active_portfolio_id &&
          optimization_params[active_portfolio_id] &&
          optimization_params[active_portfolio_id]["max_vol"]
        ? optimization_params[active_portfolio_id]["max_vol"]
        : 0;

    let min_return =
      direct_review_portfolio &&
      direct_review_scenario_id &&
      direct_review_optimization_params[direct_review_scenario_id.toString()] &&
      direct_review_optimization_params[direct_review_scenario_id.toString()][
        "min_return"
      ]
        ? direct_review_optimization_params[
            direct_review_scenario_id.toString()
          ]["min_return"]
        : active_portfolio_id &&
          optimization_params[active_portfolio_id] &&
          optimization_params[active_portfolio_id]["min_return"]
        ? optimization_params[active_portfolio_id]["min_return"]
        : 0;

    let upper_bound =
      direct_review_portfolio &&
      direct_review_scenario_id &&
      direct_review_optimization_params[direct_review_scenario_id.toString()] &&
      direct_review_optimization_params[direct_review_scenario_id.toString()][
        "upper_bounds"
      ]
        ? direct_review_optimization_params[
            direct_review_scenario_id.toString()
          ]["upper_bounds"]
        : active_portfolio_id &&
          optimization_params[active_portfolio_id] &&
          optimization_params[active_portfolio_id]["upper_bounds"]
        ? optimization_params[active_portfolio_id]["upper_bounds"]
        : 0;
    // if length is lessthan 5 add empty card
    let modelPortfolioModified;

    if (modelportfolios && modelportfolios.length < 4) {
      let modified = [...modelportfolios];
      let obj = {
        name: "",
        id: "",
        data: [],
      };
      modified.push(obj, obj);
      modelPortfolioModified = modified;
    } else {
      modelPortfolioModified = modelportfolios;
    }
    return (
      <div className="BuildPortfolio">
        <div className="BuildPortfolio_card_holder">
          {modelPortfolioModified &&
          modelPortfolioModified.length > 0 &&
          // Object.keys(backtest_data).length > 0 &&
          build_histmetrics &&
          Object.keys(build_histmetrics).length > 0 ? (
            <Slider {...SliderSettings}>
              {modelPortfolioModified.map((obj) => (
                <div key={`key-${obj.id}`}>
                  <ContainerDimensions>
                    {({ width }) => (
                      <Fragment>
                        {width > 0 ? (
                          <ModelCard
                            id={`build-portfolio-cards-${obj.id}`}
                            val={obj.id}
                            width={width}
                            radioButtonHandler={this.radioButtonHandler}
                            defaultChecked={
                              obj.id === active_portfolio_id ? true : false
                            }
                            disableRadioButton={
                              (direct_review_orig_scenario_id === 0 ||
                                direct_review_orig_scenario_id === "") &&
                              direct_review_portfolio === false
                                ? false
                                : direct_review_orig_scenario_id &&
                                  direct_review_portfolio === true &&
                                  direct_review_orig_scenario_id.toString() ===
                                    obj.id
                                ? false
                                : true
                            }
                            headingTxt={`${
                              obj["data"] &&
                              obj["data"][0] &&
                              obj["data"][0]["scenario_name"]
                                ? obj["data"][0]["scenario_name"]
                                : obj["data"] && obj["data"][0]
                                ? obj["data"][0]["description"]
                                : ""
                            }`}
                            footerTxt={"Start with this portfolio"}
                            // backtest_data={backtest_data}
                            perfHistmetrics={build_histmetrics[obj.id]}
                            benchmarkName={
                              obj["data"] &&
                              obj["data"][0] &&
                              obj["data"][0]["benchmark_name"]
                                ? `${obj["data"][0]["benchmark_name"]}`
                                : null
                            }
                            noOpacity={
                              obj.id === active_portfolio_id ? true : false
                            }
                            active_portfolio_id={active_portfolio_id}
                            radioButtonName="buildPortfolio"
                          />
                        ) : null}
                      </Fragment>
                    )}
                  </ContainerDimensions>
                </div>
              ))}
            </Slider>
          ) : null}
        </div>
        {active_portfolio_id && Object.keys(idAssociatedValue).length > 0 ? (
          <div>
            <RiskRangeChart
              min={minRange}
              max={maxRange}
              value={idAssociatedValue[active_portfolio_id]}
            />
          </div>
        ) : null}

        {active_portfolio_id ? (
          <Fragment>
            <TreeTableWithSlider
              activePortfolioID={
                direct_review_portfolio && direct_review_scenario_id
                  ? direct_review_scenario_id
                  : active_portfolio_id
              }
              getScenarioShortlist={
                direct_review_portfolio &&
                direct_review_scenario_shortlist_symbols &&
                direct_review_scenario_shortlist_symbols.length > 0
                  ? direct_review_scenario_shortlist_symbols
                  : this.props.scenario_short_list_symbols[active_portfolio_id]
              }
              overall_focus={
                direct_review_portfolio && direct_review_overall_focus
                  ? direct_review_overall_focus
                  : overall_focus
              }
              asset_class={
                direct_review_portfolio && direct_review_asset_class
                  ? direct_review_asset_class
                  : asset_class
              }
              styles={
                direct_review_portfolio && direct_review_styles
                  ? direct_review_styles
                  : styles
              }
              setDualSliderValues={this.sliderRangeHandler}
              type="build_a_portfolio"
              single_asset_class_style={true}
              buildPortfolioType={build_a_portfolio_type}
              deleteRow={
                build_a_portfolio_type === "managerSelection" ||
                build_a_portfolio_type === "customPortfolio"
                  ? true
                  : false
              }
              listOfSecuritiesToDelete={this.props.listOfSecuritiesToDelete}
              undoListOfSecuritiesToDelete={
                this.props.undoListOfSecuritiesToDelete
              }
              setSymbolsOrder={this.props.setSymbolsOrder}
              symbol_orders={this.props.symbol_orders}
              deleteSecurities={this.props.deleteSecurities}
              allocationInputField={
                build_a_portfolio_type === "customPortfolio" ? true : false
              }
              allocationHandler={this.props.allocationHandler}
              allocation_max_limit={
                direct_review_portfolio && direct_review_scenario_id
                  ? direct_review_optimization_params[
                      direct_review_scenario_id
                    ]["upper_bounds"]
                  : optimization_params &&
                    active_portfolio_id &&
                    optimization_params[active_portfolio_id] &&
                    optimization_params[active_portfolio_id]["upper_bounds"]
              }
            />
            {active_portfolio_id && (
              <TunersAndInput
                str1="cr1"
                str2="cr2"
                str3="cr3"
                volatality={max_value}
                returns={min_return}
                max_limit={upper_bound}
                tunersHandler={this.tunersHandler}
                scenario_id={
                  direct_review_portfolio
                    ? direct_review_scenario_id
                    : active_portfolio_id
                }
                volatility_type="max_vol"
                return_type="min_return"
                max_limit_type="upper_bounds"
                scenario_name={scenario_name}
                portfolioNameHandler={this.portfolioNameHandler}
                btnDisabled={createBtnDisabled}
                btnHandler={this.createPortfolioHandler}
                creatingPortfolioSpinner={creatingPortfolioSpinner}
                failedCreatingPortfolio={failedCreatingPortfolio}
                noScenarioIDreturned={noScenarioIDreturned}
                displayTuners={
                  build_a_portfolio_type === "managerSelection" ? false : true
                }
              />
            )}
          </Fragment>
        ) : null}
      </div>
    );
  }
}
export default connect(
  ({
    buildPortfolio: {
      build_a_portfolio_type,
      build_a_portfolio: {
        active_portfolio_id,
        scenario_name,
        deleteSecurities,
        symbol_orders,
      },
      build_modelportfolios,
      scenario_short_list_symbols,
      // backtest_data,
      build_histmetrics,
      backendParams: {
        optimization_params,
        overall_focus,
        asset_class,
        styles,
        fund_type,
      },
      direct_review: {
        direct_review_orig_scenario_id,
        direct_review_portfolio,
        direct_review_scenario_id,
        direct_review_optimization_params,
        direct_review_fund_type,
        direct_review_asset_class,
        direct_review_overall_focus,
        direct_review_styles,
        direct_review_scenario_shortlist_symbols,
      },
    },
  }) => ({
    build_a_portfolio_type,
    active_portfolio_id,
    scenario_name,
    build_modelportfolios,
    scenario_short_list_symbols,
    // backtest_data,
    build_histmetrics,
    optimization_params,
    overall_focus,
    asset_class,
    styles,
    fund_type,
    symbol_orders,
    deleteSecurities,
    direct_review_orig_scenario_id,
    direct_review_portfolio,
    direct_review_scenario_id,
    direct_review_optimization_params,
    direct_review_fund_type,
    direct_review_asset_class,
    direct_review_overall_focus,
    direct_review_styles,
    direct_review_scenario_shortlist_symbols,
  }),
  (dispatch) => ({
    setBuildAPortfolioID: ({ activePortfolioID, group }) =>
      dispatch({
        type: "BUILD_SET_ACTIVE_PORTFOLIO",
        payload: { activePortfolioID, group },
      }),
    setBuildScenarioName: ({ scenario_name, group }) =>
      dispatch({
        type: "BUILD_SET_SCENARIO_NAME",
        payload: { scenario_name, group },
      }),

    setDualSliderValues: (obj) =>
      dispatch({
        type: "BUILD_COMMON_DUAL_SLIDER_HANDLER",
        payload: obj,
      }),
    tunersHandler: ({ id, type, value }) =>
      dispatch({
        type: "COMMON_TUNERS_HANDLER",
        payload: { id, type, value },
      }),
    listOfSecuritiesToDelete: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_LIST_OF_SECURITIES_TO_DELETE",
        payload,
      }),
    undoListOfSecuritiesToDelete: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_LIST_OF_SECURITIES_TO_DELETE_UNDO",
        payload,
      }),
    setSymbolsOrder: (payload) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SYMBOLS_ORDER",
        payload,
      }),
    resetBuildPortfolio: () =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_RESET",
      }),

    allocationHandler: ({ symbol, value }) =>
      dispatch({
        type: "BUILD_A_PORTFOLIO_SET_ALLOCATION",
        payload: { symbol, value },
      }),
    resetBuildDirectReview: () =>
      dispatch({
        type: "RESET_BUILD_DIRECT_REVIEW",
      }),
  })
)(BuildPortfolio);



// WEBPACK FOOTER //
// ./src/components/pages/Create_portfolio_by_Advisor/build_portfolio/BuildPortfolio.jsx